import { useState } from "react";
import api, { formatApiError, money } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { PaymentsInbox } from "@/components/PaymentsInbox";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function AdminPayments() {
  const [open, setOpen] = useState(false);
  const [running, setRunning] = useState(false);

  const runRenewals = async () => {
    setRunning(true);
    try {
      const { data } = await api.post("/billing/renewals/run", {});
      toast.success(`Renewals ${data.period}: ${data.succeeded} charged (${money(data.charged_minor)}), ${data.failed} failed, ${data.skipped} skipped.`);
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-payments-page">
      <div className="flex items-start justify-between gap-4">
        <PageHeader title="Billing — Payments"
          subtitle="Incoming cash top-up requests from direct customers and resellers. Balances change only on approval." />
        <Button variant="outline" className="rounded-lg shrink-0" data-testid="run-renewals-btn"
          onClick={() => setOpen(true)}>
          <ArrowsClockwise className="w-4 h-4 mr-1.5" weight="bold" /> Run monthly renewals
        </Button>
      </div>

      <PaymentsInbox />

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="renewals-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Run monthly renewals now?</AlertDialogTitle>
            <AlertDialogDescription>
              This renews the current concurrent-call capacity for every customer and reseller for
              the current month, charging each account's stored per-channel price. Accounts already
              renewed this month are skipped (no double charge); accounts without enough balance have
              their limit set to 0.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="renewals-cancel-btn">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="renewals-confirm-btn" disabled={running}
              onClick={(e) => { e.preventDefault(); runRenewals(); }}>
              {running ? "Running…" : "Run renewals"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
